/**
 * Geo redirect banner (India store).
 * Shows for AE visitors only; uses browsing_context_suggestions.json + sessionStorage.
 */
(() => {
  'use strict';

  const STORAGE_KEY = 'geoRedirectHandled';
  const UAE_STORE_URL = 'https://knyamed.global/';

  async function getVisitorCountry() {
    try {
      const response = await fetch(`${window.location.origin}/browsing_context_suggestions.json`, {
        credentials: 'same-origin',
      });
      if (!response.ok) return null;

      const handle = (await response.json())?.detected_values?.country?.handle;
      return typeof handle === 'string' ? handle.toUpperCase() : null;
    } catch (error) {
      console.warn('[geo-redirect] Failed to detect country:', error);
      return null;
    }
  }

  async function initGeoRedirect() {
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') return;

    const banner = document.getElementById('geo-redirect-banner');
    if (!banner) return;

    const yesBtn = banner.querySelector('[data-geo-redirect-yes]');
    const noBtn = banner.querySelector('[data-geo-redirect-no]');
    const storeLink = banner.querySelector('[data-geo-redirect-link]');

    const markHandled = () => sessionStorage.setItem(STORAGE_KEY, 'true');
    const hideBanner = () => {
      banner.classList.remove('is-visible');
      banner.hidden = true;
    };
    const redirectToUAEStore = () => {
      markHandled();
      window.location.href = UAE_STORE_URL;
    };

    yesBtn?.addEventListener('click', redirectToUAEStore);
    noBtn?.addEventListener('click', () => {
      markHandled();
      hideBanner();
    });
    storeLink?.addEventListener('click', (event) => {
      event.preventDefault();
      redirectToUAEStore();
    });

    const country = await getVisitorCountry();
    if (country !== 'AE') return;

    banner.hidden = false;
    banner.classList.add('is-visible');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGeoRedirect);
  } else {
    initGeoRedirect();
  }
})();
